// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "./store/store.js";
import ElementUI from "element-ui";
import 'element-ui/lib/theme-chalk/index.css';
import VueMoment from 'vue-moment'
import moment from 'moment-timezone'
import {description} from '../package.json';

Vue.use(ElementUI);
Vue.use(VueMoment, {
  moment,
});
//启动时的生产提示
Vue.config.productionTip = false;
// axios
import axios from "axios";
import Qs from "qs";
axios.defaults.transformRequest = [function (data) {
  if (data.toString() == "[object FormData]") {
    return data;
  } else {
    return Qs.stringify(data)
  }
}];
console.log(description);
let isAppInit = false;

let initApp = function () {

  if (isAppInit) {
    console.log('vue already loaded.');
    return;
  } else {
    console.log('Vue  is not loaded.');
  }

  const instance = axios.create({
    baseURL: localStorage.lineUrl,
    timeout: 10000,
    withCredentials: true
  });
  Vue.prototype.$http = instance;

  sessionStorage.removeItem('lineUrl')
  /**
   * wonder chat system start
   */
  const wonderChatInstace = axios.create({
    baseURL: process.env.WONDER_CHAT_ROOT,
    timeout: 10000,
    withCredentials: true
  });
  Vue.prototype.$wonderChat = wonderChatInstace;

  //end wonder chat system
  //Vue.prototype.$http = instance;

  //force logout and goto login
  Vue.prototype.$logout = function (msg) {
    this.$toast.fail(msg);
    setTimeout(() => {
      this.$store.commit("changeLoginType", false);
      sessionStorage.setItem("token", "");
      localStorage.clear();
      this.$router.push("/login");
      window.location.reload();
    }, 2000);
  };

  // Common loader
  Vue.prototype.$NoNetworkErrorMsg = "网络连接失败,稍后再试";
  Vue.prototype.$ShowCommonLoading = function () {
    return this.$toast.loading({
      duration: 0, // 持续展示 toast
      forbidClick: true,
      overlay: true,
      message: "加载中...",
    });
  };


  Vue.prototype.$LoadFromDomain = process.env.LOAD_FROM_DOMAIN;
  Vue.prototype.$AutoLogin = process.env.AUTO_LOGIN;
  Vue.prototype.$DownloadPopup = process.env.DOWNLOAD_POPUP;

  new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
  });

  router.afterEach((to, from, next) => {
    window.scrollTo(0, 0);
  });

  isAppInit = true;
}

Vue.prototype.$chatApiURL = process.env.WONDER_CHAT_ROOT;

let Line_1 = window.__env.Line_1;//"https://server3299.hk99666.com/";
let Line_2 = window.__env.Line_2;//"https://server3299.hk99111.com/";

Vue.prototype.$URLs = [{ "id": 1, "name": "线路一", "url": window.__env.API_ROOT }, { "id": 2, "name": "线路二", "url": Line_1 }, { "id": 3, "name": "线路三", "url": Line_2 }];
let lines = Vue.prototype.$URLs;


let workingLines = [];

let checkLine = function (url) {
  return new Promise((resolve, reject) => {
    console.log('check line url ', url);
    if (url === null || url === undefined) { reject(); return; };

    const controller = new AbortController();
    const signal = controller.signal;

    // Set a timeout to abort the request after a certain time
    const timeoutId = setTimeout(() => {
      controller.abort();
      console.log('Request aborted due to timeout');
    }, 5000); // Abort after 5 seconds (adjust as needed)

    fetch(url, { mode: 'no-cors', signal })
      .then(response => {
        clearInterval(timeoutId);
        resolve();
      })
      .catch(error => {
        clearInterval(timeoutId);
        reject();
      });


  });
}

async function startAppWithFirstWorkingLine(urls) {
  for (const item of urls) {
    try {
      const controller = new AbortController();
      const signal = controller.signal;
      const fetchPromise = fetch(item.url, { signal });

      // Set a timeout to abort the request after a certain time
      const timeoutId = setTimeout(() => {
        controller.abort();
        console.log('Request aborted due to timeout');
      }, 5000); // Abort after 5 seconds (adjust as needed)


      let startTime = new Date().getTime();
      fetchPromise.then((res) => {
        if (res.ok) {
          let ci = urls.find((o) => o.url === res.url);
          localStorage.setItem('lineUrl', ci.url);
          sessionStorage.setItem('lineUrl', ci.url);
          localStorage.setItem('lineUrlText', ci.name);
          sessionStorage.setItem('lineUrlText', ci.name);
          localStorage.setItem('lineUrlId', ci.id);
          sessionStorage.setItem('lineUrlId', ci.id);
          clearInterval(timeoutId);

          let endTime = new Date().getTime();
          let elapsedTime = endTime - startTime;
          let i = {};
          i.time = elapsedTime;
          i.url = ci.url;
          i.name = ci.name;
          i.id = ci.id;

          workingLines.push(item);
        }



        initApp();
        return;
       
      });

      fetchPromise.catch((error) => {
        clearInterval(timeoutId);
        console.error(`Error fetching URL ${item.url}:`, error);
      })
    } catch (error) {
      clearInterval(timeoutId);
      console.error(`Error fetching URL ${item.url}:`, error);
    }
  }

  // If we reach here, no working URL was found
  console.log('No working URL found.');
}

//check url param fixed api line
const urlParams = new URLSearchParams(window.location.hash.split('?')[1])
const paramValue = urlParams.get('line');
console.log(paramValue && !localStorage.lineUrl);
if (paramValue && !localStorage.lineUrl) {
  let lineNum = paramValue.split('api')[1];

  let paramLine = lines[parseInt(lineNum) - 1];


  localStorage.setItem('lineUrl', paramLine.url);
  sessionStorage.setItem('lineUrl', paramLine.url);
  localStorage.setItem('lineUrlText', paramLine.name);
  sessionStorage.setItem('lineUrlText', paramLine.name);
  localStorage.setItem('lineUrlId', paramLine.id);
  sessionStorage.setItem('lineUrlId', paramLine.id);

  // console.log(paramLine, parseInt(lineNum)-1);
}

let storedLine = localStorage.lineUrl;
checkLine(storedLine).then(() => {
  workingLines = lines;
  initApp();
}).catch(() => {
  startAppWithFirstWorkingLine(lines);



})




// WEBPACK FOOTER //
// ./src/main.js